/* tslint:disable */
/* eslint-disable */
export enum CohortTypeEnum {
  DEFAULT = 'Default',
  DEFINED = 'Defined',
  ASPIRATIONAL = 'Aspirational'
}
